export const enRoles = {
  title: "Roles",
  subtitle: "View all roles and the permissions assigned to them.",
  empty: "No roles found.",
  actions: {
    newRole: "New Role",
    editRoleAria: "Edit role {{name}}",
  },
  newRoleModal: {
    title: "New Role",
    editTitle: "Edit Role",
    closeAria: "Close dialog",
    fields: {
      name: "Role name",
      permissions: "Permissions",
      selectAll: "Select All",
    },
    validation: {
      required: "This field is required.",
    },
    actions: {
      cancel: "Cancel",
      addRole: "Add Role",
      saveRole: "Save Changes",
    },
    errors: {
      saveFailed: "Failed to add role. Please try again.",
      updateFailed: "Failed to update role. Please try again.",
    },
  },
  table: {
    name: "Name",
    permissions: "Permissions",
    permissionCount: "{{count}} permissions",
    createdAt: "Created",
    ariaLabel: "Roles",
  },
} as const;
